import { Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { DialogCreator } from 'sharedFeatures/sharedGui/components/window/dialog-creator';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styles: []
})
export class AppComponent extends DialogCreator implements OnInit {

    public rootPageName: string = window.rootPageName;

    constructor(private viewContainerRef: ViewContainerRef,
                private element: ElementRef)
    {
        super();
    }

    ngOnInit() {
    }

    getElement(): Element {
        return this.element.nativeElement;
    }

    getViewContainerRef(): ViewContainerRef {
        return this.viewContainerRef;
    }
}